import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import styles from "./TravelDealsPage.module.scss";
import {
  DealTileSkeleton,
  TravelDealTile,
  useTravelDeals,
} from "@/modules/dealTiles";
import { HtsMediaDealTilePlacement } from "@/modules/htsMedia";
import { OfferTerms } from "@/pages/HotelFundedOffers/OfferTerms";
import { OfferScreen } from "@/tracking/offers";

const SKELETON_COUNT = 8;

/** All travel deals (Figma 2002:40532): sponsored HTS Media tiles first, then funded hotel deals. */
export const TravelDealsPage = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "TravelDealsPage");
  const { deals, isLoading } = useTravelDeals(
    HtsMediaDealTilePlacement.DealsPage
  );

  return (
    <div className={block}>
      <div className={cn("body")}>
        <h1 className={cn("title")}>{t("hotelDealsSection.title")}</h1>
        <div className={cn("grid")}>
          {isLoading
            ? Array.from({ length: SKELETON_COUNT }).map((_, index) => (
                <DealTileSkeleton key={index} />
              ))
            : deals.map((deal, index) => (
                <TravelDealTile
                  key={deal.key}
                  deal={deal}
                  tileIndex={index}
                  screen={OfferScreen.deals_page}
                />
              ))}
        </div>
        {!isLoading && deals.length === 0 && (
          <p className={cn("empty")}>{t("travelDealsPage.empty")}</p>
        )}
      </div>
      <OfferTerms />
    </div>
  );
};
